import React from 'react';
import { purple } from 'globals/colors';

interface FsArrowRightIconProps {
  color?: string;
}

const FsArrowRightIcon: React.FC<FsArrowRightIconProps> = ({
  color = purple.BRAND,
}) => {
  return (
    <svg
      width="15"
      height="12"
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 6.00049L12 6.00049"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M9.00045 1.75785L13.2431 6.00049L9.00045 10.2431"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default FsArrowRightIcon;
